import { fmtMileage } from './helpers';

/** The business purpose, with the mileage breakdown and attendees beneath it. */
const PurposeCell = ({ expense, maxWidth = 280 }) => {
  const mileage = fmtMileage(expense);
  return (
    <td style={{ maxWidth }}>
      {expense.description}
      {mileage && <div className="small text-muted">{mileage}</div>}
      {expense.attendees && <div className="small text-muted">Attendees: {expense.attendees}</div>}
    </td>
  );
};

export default PurposeCell;
